import { useEffect, useRef, useState } from 'react';
import './ProfileMenu.css';

// A tiny 8x10 pixel-art sprite (hooded adventurer head + shoulders) used as
// the profile icon - keeps the retro-game feel of the rest of the UI
// instead of a flat/modern glyph. 1 = filled pixel (rendered in the
// button's current color), 0 = left empty so the button's background
// shows through.
const PROFILE_SPRITE = [
  [0, 0, 0, 1, 1, 0, 0, 0],
  [0, 0, 1, 1, 1, 1, 0, 0],
  [0, 1, 1, 1, 1, 1, 1, 0],
  [1, 1, 1, 1, 1, 1, 1, 1],
  [1, 1, 0, 1, 1, 0, 1, 1],
  [1, 1, 1, 1, 1, 1, 1, 1],
  [0, 1, 1, 1, 1, 1, 1, 0],
  [0, 0, 1, 1, 1, 1, 0, 0],
  [0, 1, 1, 1, 1, 1, 1, 0],
  [1, 1, 1, 1, 1, 1, 1, 1],
];

function ProfileIcon() {
  return (
    <svg
      className="profile-icon"
      viewBox="0 0 8 10"
      shapeRendering="crispEdges"
      fill="currentColor"
      aria-hidden="true"
    >
      {PROFILE_SPRITE.flatMap((row, y) =>
        row.map((pixel, x) =>
          pixel ? <rect key={`${x}-${y}`} x={x} y={y} width="1" height="1" /> : null
        )
      )}
    </svg>
  );
}

export default function ProfileMenu({ onSelectProfile, onLogout, loggingOut }) {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);

  useEffect(() => {
    if (!open) return;

    function handleClickOutside(event) {
      if (rootRef.current && !rootRef.current.contains(event.target)) {
        setOpen(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [open]);

  function handleSelectProfile() {
    setOpen(false);
    onSelectProfile();
  }

  return (
    <div className="profile-menu" ref={rootRef}>
      <button
        type="button"
        className="profile-button"
        onClick={() => setOpen((prev) => !prev)}
        aria-haspopup="true"
        aria-expanded={open}
        aria-label="Profile menu"
        title="Profile menu"
      >
        <ProfileIcon />
      </button>

      {open && (
        <div className="profile-dropdown" role="menu">
          <button
            type="button"
            className="profile-menu-item"
            role="menuitem"
            onClick={handleSelectProfile}
          >
            PROFILE
          </button>
          <button
            type="button"
            className="profile-menu-item"
            role="menuitem"
            onClick={onLogout}
            disabled={loggingOut}
          >
            {loggingOut ? 'LOGGING OUT...' : 'LOGOUT'}
          </button>
        </div>
      )}
    </div>
  );
}
